"use strict";
import {http} from '../../../core';
const RequestService = http.create();

export default {
    // 非工单工时列表
    getNonWorkList:function (params) {
        return RequestService.get("user_statistics/no_order/list",params);
    },
    nonOrderAdd:function (params) {
        return RequestService.post("user_statistics/no_order/add",params);
    },
    nonOrderEdit:function (params) {
        return RequestService.post("user_statistics/no_order/edit",params);
    },
    // 详情
    detailList:function (params) {
        return RequestService.get("user_statistics/no_order/detail",params);
    },
    // 派工统计列表
    nonOrderDele:function (params) {
        return RequestService.post("user_statistics/no_order/delete",params);
    },
}
